import styled, { css } from 'styled-components';
import FormContainerField, { FormContainerFieldError } from '../../form-container-field';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * FormOptionCardContainer
 */
export const formOptionCardContainerStyles = ({ theme }) => css `
	${FormContainerFieldError} {
		margin-top: ${pxToRem(theme.spacing['100'])};
	}
`;
export const FormOptionCardContainer = styled(FormContainerField) `
	${formOptionCardContainerStyles}
`;
